if (!customElements.get('mc-collections-page')) {
  customElements.define('mc-collections-page', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.filters = Array.from(this.querySelectorAll('[data-collection-filter]'));
      this.cards = Array.from(this.querySelectorAll('.collection-block'));
      this.status = this.querySelector('[data-collection-status]');
      if (!this.filters.length || !this.cards.length) return;
      this.filterList = this.querySelector('[data-collection-filters]');
      this.filterBar = this.querySelector('[data-collection-filter-bar]');
      this.navigation = this.querySelector('[data-collection-navigation]');
      this.previous = this.querySelector('[data-collection-previous]');
      this.next = this.querySelector('[data-collection-next]');
      this.filterList.hidden = false;
      this.filters.forEach(button => {
        button.addEventListener('click', () => this.setFilter(button), options);
      });
      const advanceFilter = direction => {
        const selected = this.filters.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        const button = this.filters[selected + direction];
        if (button) this.setFilter(button);
      };
      this.previous?.addEventListener('click', () => advanceFilter(-1), options);
      this.next?.addEventListener('click', () => advanceFilter(1), options);
      this.filterResize = new ResizeObserver(() => this.updateNavigation());
      if (this.filterBar) {
        [this.filterBar, ...this.filters].forEach(element => this.filterResize.observe(element));
      }
      this.setFilter(this.filters[0]);
    }

    setFilter(button) {
      const category = button.dataset.collectionFilter;
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.mcCategory?.trim() !== category;
        if (!card.hidden) count += 1;
      });
      this.filters.forEach(filter => {
        filter.setAttribute('aria-pressed', String(filter === button));
      });
      const label = count === 1 ? this.dataset.countOne : this.dataset.countMany;
      this.status.textContent = button.textContent.trim() + ': ' + count + ' ' + label;
      const bounds = this.filterList.getBoundingClientRect();
      const buttonBounds = button.getBoundingClientRect();
      if (buttonBounds.left < bounds.left) this.filterList.scrollLeft += buttonBounds.left - bounds.left;
      else if (buttonBounds.right > bounds.right) this.filterList.scrollLeft += buttonBounds.right - bounds.right;
      this.updateNavigation();
    }

    updateNavigation() {
      const selected = this.filters.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      if (this.previous) this.previous.disabled = selected <= 0;
      if (this.next) this.next.disabled = selected >= this.filters.length - 1;
      if (!this.filterBar || !this.navigation) return;
      const gap = parseFloat(getComputedStyle(this.filterList).columnGap) || 0;
      const width = this.filters.reduce((total, button) => total + button.getBoundingClientRect().width, 0) + gap * Math.max(0, this.filters.length - 1);
      const fits = width <= this.filterBar.clientWidth + 1;
      this.filterBar.toggleAttribute('data-filters-fit', fits);
      this.navigation.hidden = fits;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.filterResize?.disconnect();
      this.controller = null;
    }
  });
}

